import fetchJSON from '@gaia/utils/fetchJSON';
import useSWR, {preload} from 'swr';
import {z} from 'zod';

export type Banner = {message: string; hash: string};

export const bannerKey = 'specialAnnouncement';

preload(bannerKey, fetcher);

async function hashMessage(message: string) {
    // convert the Javascript string (UTF-16) into an array of UTF-8 bytes
    const messageUTF8 = new TextEncoder().encode(message);

    // hash the message into an array of bytes
    const hashBytes = new Uint8Array(await crypto.subtle.digest('SHA-1', messageUTF8));

    // convert the array of bytes into a hex string
    const hex = Array.from(hashBytes, (byte) => `00${byte.toString(16)}`.slice(-2)).join('');

    return hex;
}

const fallbackData = {
    message: '',
    hash: 'da39a3ee5e6b4b0d3255bfef95601890afd80709',
};

async function fetcher(): Promise<Banner> {
    const {message} = await fetchJSON(
        'https://static.gaiagps.com/announcement.json',
        undefined,
        z.object({message: z.string()})
    );
    return {message, hash: await hashMessage(message)};
}

type SWRBannerOptions = Parameters<typeof useSWR<Banner>>[2];

export function useBanner(options?: SWRBannerOptions): Banner | undefined {
    return useSWR<Banner>(bannerKey, {
        fetcher,
        fallbackData,
        ...options,
    }).data;
}
